import React, { useMemo } from 'react';
import { AlertZoneIcon } from '../../styled';
import { TbAlertTriangleFilled } from 'react-icons/tb';
import { useQueueContentChatContext } from '../../../../../../../hooks/useQueueContentChat';

const AlertAgentTag = ({ chatId }) => {
  const {
    chatsAgentWithoutInteractionCritical,
    chatsAgentWithoutInteractionWarning
  } = useQueueContentChatContext();

  const type = useMemo(() => {
    if (chatsAgentWithoutInteractionCritical.has(chatId)) {
      return 'critical';
    }
    if (chatsAgentWithoutInteractionWarning.has(chatId)) {
      return 'warning';
    }
    return 'default';
  }, [
    chatId,
    chatsAgentWithoutInteractionCritical,
    chatsAgentWithoutInteractionWarning
  ]);

  if (type === 'default') {
    return <> </>;
  }

  return (
    <AlertZoneIcon type={type}>
      <TbAlertTriangleFilled size="12" color="#fff" />
    </AlertZoneIcon>
  );
};

export default AlertAgentTag;
